import React from 'react';

const Footer = () => {
    return (
        
            <footer class="text-center p-6 bg-black text-white">
                <p>Copyright © 2022 - All right reserved by <b>Faisal Karim</b></p>
            </footer>
        
    );
};

export default Footer;